<template>
  <b-container class="post-magazines-container">
    <h3 class="title-text">Magazine Archive</h3>
    <p class="title-second-text">Here you can search and find all the CC-Magazine issues </p>
    <div class="functional-row">
      <button class="btn"
        @click="$router.go(-1)"
      > <b>&#60;</b> Back</button>
      <div class="filterArea">
        <label for="" class="searchArea">
          <input type="text" v-model="searchInput">
          <i class="fas fa-search"></i>
        </label>
        <div
          @click="filterByYear()"
          class="ml-2" :class="{active: activeClass === 'year'}"
        >Year <i class="fas fa-chevron-down mr-2"></i></div>
        <div
          @click="filterByEvent()"
          :class="{active: activeClass === 'event'}"
          >Event <i class="fas fa-chevron-down mr-2"></i>
        </div>
      </div>
    </div>
    <div v-if="!magazines.length" class="text-for-empty">There is no magazine to show.</div>
    <div v-else class="gridMagazineGallery">
      <div v-for="(magazine, index) in magazines" :key="index">
        <div class="mt-3 mb-4">
          <b-row class="justify-content-md-center">
            <b-col class="media-col">
              <i class="fa fa-file"></i>
              <a target="_blank" :href="magazine.post_guide" download>
                <div class="media-download">
                  <i class="fa fa-download" aria-hidden="true"> </i>
                  Post Guide
                </div>
              </a>
            </b-col>
          </b-row>
        </div>
        <p>GCCM - CEE 2019 - Berlin</p>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
// import axios from 'axios';

export default {
  name: 'MagazineArchive',
  data() {
    return {
      activeClass: null,
      searchInput: null,
      magazines: [

      ],
    };
  },
  created() {
    this.event = this.$route.params.event;
  },
  async mounted() {
    // console.log(this.event);
    // if (this.$route.params.eventId) {
    // this.magazines = await this.fetchPostGuide(this.$route.params.eventId);
    // }
    // axios.get(this.event)
  },
  methods: {
    ...mapActions({
      // fetchPostGuide: 'events/fetchPostGuide',
    }),
    // to do
    filterByEvent() {
      this.activeClass = 'event';
    },
    // to do
    filterByYear() {
      this.activeClass = 'year';
    },
    getHostName(url) {
      let magazineType = 'vimeo';
      const regex = new RegExp(
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?.*/,
      );
      if (regex.test(url)) {
        magazineType = 'youtube';
      }
      return magazineType;
    },
    // findMagazine(value) {
    // const magazines = [this.magazines];
    // if (this.searchInput) {
    //   const filtered = magazines.filter(magazine => magazine.name.includes(this.searchInput));
    //   return filtered;
    // }
    // return this.magazines;
    // },
  },
  watch: {
    searchInput: {
      // handler(value) {
      //   this.findMagazine(value);
      // },
    },
  },
};
</script>
<style src="./PrevEditionStyles.css" scoped></style>
<style scoped>
.post-magazines-container {
  padding: 0;
  font-family: Montserrat;
}
.post-magazines-container > p {
  font-family: Montserrat;
  font-size: 15px;
  color: #666;
}
.gridMagazineGallery {
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
}
.media-col {
  max-width: 235px;
  height: 79px;
  text-align: center;
  margin: 1px 20px 1px 20px;
  background: #BD9D5F;
}
.media-col > i {
  color: white;
  font-size: 30px;
  margin-top: 26px;
}
.media-download {
  background: #BD9D5F;
  color: white;
  width: 100%;
  position: absolute;
  top: 80px;
  left: 0px;
  height: 24px;
  text-align: center;
  cursor: pointer;
}
.media-download > p {
  font-size: 10px;
  font-family: Arial;
  line-height: 1.17;
}
.media-download:hover {
  opacity: 0.5;
  transition: 0.3s;
}
.download-btn {
  background: transparent;
  height: 23px;
  font-size: 12px;
  border: unset;
}
.media-download > a {
  color: white;
}

</style>
